
export type GetUsers200DataItem = {
  avatar?: string;
  bio?: string;
  displayName?: string;
  followersCount?: number;
  followingCount?: number;
  id?: string;
  username?: string;
  verified?: boolean;
};
